// extracted by mini-css-extract-plugin
export default {"form":"registerForm_form__DuU0I"};